export const splitCardExample = (exampleValue: string) => {
  const firstX = exampleValue.indexOf('X')
  const lastX = exampleValue.lastIndexOf('X')

  if (firstX === -1) return { prefix: '', mask: exampleValue, suffix: '' }

  return {
    prefix: exampleValue.slice(0, firstX).trim(),
    mask: exampleValue.slice(firstX, lastX + 1),
    suffix: exampleValue.slice(lastX + 1).trim(),
  }
}

export const applyCardMask = (mask: string, value: string) => {
  const digits = value.replace(/[^0-9]/g, '')
  const slots = mask.match(/X/g)?.length ?? 0

  if (!slots || digits.length !== slots) return null

  let index = 0
  return mask.replace(/X/g, () => digits[index++])
}

export const fillCardMask = (mask: string) => {
  let counter = 1
  return mask.replace(/X/g, () => {
    const current = counter
    counter = counter === 9 ? 1 : counter + 1
    return String(current)
  })
}
